import React, { useId } from 'react'
import PropTypes from 'prop-types'

const ChevronLeftIcon = React.forwardRef(function ChevronLeftIcon(props, ref) {
  const { color, size, ...otherProps } = props

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <path d="M15 20C14.72 20 14.44 19.88 14.24 19.65L7.67999 12L14.24 4.35001C14.6 3.93001 15.23 3.88001 15.65 4.24001C16.07 4.60001 16.12 5.23001 15.76 5.65001L10.31 12L15.75 18.35C16.11 18.77 16.06 19.4 15.64 19.76C15.46 19.92 15.23 20 15 20Z"></path>
    </svg>
  )
})

ChevronLeftIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

ChevronLeftIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default ChevronLeftIcon
